import useTspPermission from "../../../hooks/useTspPermission";
import TSP_PERMISSIONS from "../../../constants/tspPermissions";

// What a saved journey's place sections may show and record, for the signed-in
// user — the same on Edit Journey and Update Journey. Records can be added only
// while the journey runs; the server checks every request again.
//
// -> { perms, views }: `perms` for JourneyPlaceSections (tabs + what each
// section may record), `views` for useLivePlaceStore (which lists to read).
export default function useJourneyPlacePerms(journey) {
  const { hasPermission } = useTspPermission();
  const capabilities = (journey && journey.capabilities) || {};
  const active = Boolean(journey) && journey.status !== "CANCELLED";

  const perms = {
    visits: Boolean(capabilities.record_visit),
    books: active && hasPermission(TSP_PERMISSIONS.BOOK_DISTRIBUTION_MANAGE),
    accommodation: active && hasPermission(TSP_PERMISSIONS.ACCOMMODATION_MANAGE),
    media: active && hasPermission(TSP_PERMISSIONS.MEDIA_UPLOAD),
    advice: active && hasPermission(TSP_PERMISSIONS.ADVICE_MANAGE),
    response: active && hasPermission(TSP_PERMISSIONS.PUBLIC_RESPONSE_MANAGE),
  };
  const views = {
    booksView: hasPermission(TSP_PERMISSIONS.BOOK_DISTRIBUTION_VIEW),
    staysView: hasPermission(TSP_PERMISSIONS.ACCOMMODATION_VIEW),
    mediaView: hasPermission(TSP_PERMISSIONS.MEDIA_VIEW),
    adviceView: hasPermission(TSP_PERMISSIONS.ADVICE_VIEW),
    responsesView: hasPermission(TSP_PERMISSIONS.PUBLIC_RESPONSE_VIEW),
  };
  perms.mediaVisible = views.mediaView || perms.media;
  perms.adviceVisible = views.adviceView || perms.advice;
  perms.tabs = [
    (views.booksView || perms.books) && "books",
    (views.staysView || perms.accommodation) && "accommodation",
    (perms.mediaVisible || perms.adviceVisible) && "mediaAdvice",
    (views.responsesView || perms.response) && "response",
  ].filter(Boolean);

  return { perms, views };
}
